import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { Month as MonthEnum } from "features/shared/enums/monthEnum";
import { BoolEnum } from "./boolEnum";
import { ReservedCapacityChangePeriod } from "features/requirements/enums/reservedCapacityChangePeriod";
import { ContractualAccountScope } from "features/requirements/enums/contractualAccountScope";
import { ConsumptionPointScope } from "features/requirements/enums/consumptionPointScope";
import { RequirementTerminationReason } from "features/requirements/enums/requirementTerminationReason";
import { RequirementAdvanceFrequency } from "features/requirements/enums/requirementAdvanceFrequency";
import { RequirementPaymentMethod } from "features/requirements/enums/requirementPaymentMethod";

export const EnumsMap: Record<string, object>  = {
  CommodityDetail: CommodityDetail,
  MonthEnum: MonthEnum,
  BoolEnum: BoolEnum,
  ReservedCapacityChangePeriod: ReservedCapacityChangePeriod,
  ContractualAccountScope: ContractualAccountScope,
  ConsumptionPointScope: ConsumptionPointScope,
  RequirementTerminationReason: RequirementTerminationReason,
  RequirementAdvanceFrequency: RequirementAdvanceFrequency,
  RequirementPaymentMethod: RequirementPaymentMethod
}